module.exports = __webpack_public_path__ + "img/15.d0d5c7a3.webp";